import { useCurrentProject } from "@radarly/core/project/use-cases";
import { useFacetsFromQueries } from "./useFacetsFromQueries";

export function useProjectFacets() {
  const queries = useCurrentProject()?.focuses || [];
  return useFacetsFromQueries(queries);
}
